import { api } from './axios';
import type { Athlete, CreateAthleteDto } from '../types/domain';

export const athleteApi = {
  listByTeam: (teamId: number) =>
    api.get<Athlete[]>(`/admin/teams/${teamId}/athletes`).then((r) => r.data),

  listByCompetition: (competitionId: number) =>
    api.get<Athlete[]>(`/admin/competitions/${competitionId}/athletes`).then((r) => r.data),

  getById: (id: number) =>
    api.get<Athlete>(`/admin/athletes/${id}`).then((r) => r.data),

  create: (teamId: number, dto: CreateAthleteDto) =>
    api.post<Athlete>(`/admin/teams/${teamId}/athletes`, dto).then((r) => r.data),

  update: (id: number, dto: CreateAthleteDto) =>
    api.put<Athlete>(`/admin/athletes/${id}`, dto).then((r) => r.data),

  remove: (id: number) =>
    api.delete<void>(`/admin/athletes/${id}`).then(() => undefined),
};
